import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhxCardBaseComponent } from './card-base/phx-card-base.component';
import { PhxFormCardComponent } from './form-card/phx-form-card.component';
import { PhxContentCardComponent } from './content-card/phx-content-card.component';
import { PhxCardComponent } from './card/phx-card.component';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';

@NgModule({
  declarations: [
    PhxFormCardComponent,
    PhxCardBaseComponent,
    PhxContentCardComponent,
    PhxCardComponent,
  ],
  imports: [
    CommonModule,
    PhxSpinnerModule,
  ],
  exports: [
    PhxFormCardComponent,
    PhxContentCardComponent,
    PhxCardComponent,
  ]
})
export class PhxCardModule { }
